import classnames from 'classnames';
import React from 'react';

export default function ArrowIcon({ className, facingRight } = { facingRight: false }) {
  let classNames = classnames('arrowIcon', className, {
    'arrowIcon-right': facingRight,
  });
  return (
    <svg className={classNames} viewBox="0 0 94 94" version="1.1">
      <g id="Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard">
          <circle className="arrowIcon-circle" id="Oval-2" cx="46" cy="47" r="45" />
          <polyline
            className="arrowIcon-arrow"
            id="shape"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="54.9963798 66.1236891 34 46.5618445 54.9963798 27"
          />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/arrow_icon.jsx